module.exports = __webpack_public_path__ + "img/2019qinglongxia-7.714e63b7.jpg";